import queryString from 'query-string';

const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const buildKnowledgeBaseLink = (
  accountSlug: string,
  agentId: string,
  returnTo: string,
): string =>
  `/${accountSlug}/fountain_ai/ai_agent_setup?agent=${agentId}&step=train&return=${encodeURIComponent(returnTo)}`;

export const parseKnowledgeBaseLink = (
  search: string,
  accountSlug: string,
): { agentId: string; returnTo: string | null } | null => {
  const params = queryString.parse(search);
  if (
    typeof params.agent !== 'string' ||
    !uuid.test(params.agent) ||
    params.step !== 'train'
  ) {
    return null;
  }
  const escapedSlug = accountSlug.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const conversations = new RegExp(
    `^/${escapedSlug}/fountain_ai/ai_agent_setup/[0-9a-f-]{36}/conversations/?(\\?[^#]*)?$`,
  );
  return {
    agentId: params.agent,
    returnTo:
      typeof params.return === 'string' && conversations.test(params.return)
        ? params.return
        : null,
  };
};
